(function(){
  var body=document.querySelector('.shopify-policy__body'); if(!body) return;
  var rte=body.querySelector('.rte'); if(!rte) return;
  var cfg=window.WodPol||{};
  var hs=[].slice.call(rte.querySelectorAll('h2')).filter(function(h,i){return !(i===0&&h===rte.firstElementChild)});
  var nav=document.createElement('nav'); nav.className='wod-pol__nav'; nav.setAttribute('aria-label',cfg.onPage||'');
  var html='';
  if(hs.length>1){
    html+='<p class="wod-pol__navh">'+(cfg.onPage||'')+'</p><ol>';
    hs.forEach(function(h,i){ if(!h.id) h.id='sec-'+(i+1); if(i===0) h.classList.add('wod-pol__first'); html+='<li><a href="#'+h.id+'">'+h.textContent+'</a></li>'; });
    html+='</ol>';
  }
  if(cfg.others&&cfg.others.length){
    html+='<p class="wod-pol__navh wod-pol__navh--other">'+(cfg.otherTitle||'')+'</p><ul class="wod-pol__other">';
    cfg.others.forEach(function(o){ if(location.pathname.indexOf(o.u)===-1) html+='<li><a href="'+o.u+'">'+o.t+'</a></li>'; });
    html+='</ul>';
  }
  nav.innerHTML=html; body.insertBefore(nav,rte);
  var t=document.querySelector('.shopify-policy__title');
  if(t&&cfg.home){var c=document.createElement('p');c.className='wod-pol__crumb';c.innerHTML='<a href="'+cfg.homeUrl+'">'+cfg.home+'</a> › '+document.title.split(' – ')[0];t.insertBefore(c,t.firstChild);}
  var links=[].slice.call(nav.querySelectorAll('ol a'));
  if('IntersectionObserver' in window&&links.length){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){links.forEach(function(a){a.classList.toggle('is-on',a.getAttribute('href')==='#'+e.target.id)})}})},{rootMargin:'-100px 0px -70% 0px'});
    hs.forEach(function(h){io.observe(h)});
  }
})();
